'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { MARKETING } from 'self-service-api/constants/ProductLines';
import { MARKETING_HUB_BASIC } from 'self-service-api/constants/ProductNames';
import { MARKETING_PRO } from 'self-service-api/constants/UpgradeProducts';
import UIContactSalesButton from 'ui-addon-upgrades/button/UIContactSalesButton';
import UIAlert from 'UIComponents/alert/UIAlert';
import UILink from 'UIComponents/link/UILink';
import { isUngatedSelector } from '../../selectors/GatingSelectors';
import { hasProductInProductInventorySelector } from '../../selectors/ProductInventorySelectors';
import { talkToSalesTypeSelector } from '../../selectors/PurchaseMotionSelectors';

const BasicPromoBanner = ({
  promoKey,
  contactIsc
}) => /*#__PURE__*/_jsxs(UIAlert, {
  titleText: /*#__PURE__*/_jsx(FormattedMessage, {
    message: `pricingPage.promotions.marketingBasicPromoBanner.${promoKey}.title`
  }),
  type: "info",
  "data-selenium": `${promoKey}-basic-promo-banner`,
  children: [/*#__PURE__*/_jsx(FormattedMessage, {
    message: `pricingPage.promotions.marketingBasicPromoBanner.${promoKey}.body`
  }), /*#__PURE__*/_jsx(UILink, {
    className: "m-left-2",
    external: true,
    href: "https://legal.hubspot.com/marketing-basic-upgrade-terms",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricingPage.promotions.marketingBasicPromoBanner.promotionDetails"
    })
  }), /*#__PURE__*/_jsx(UIContactSalesButton, {
    isAssignable: !contactIsc,
    className: "m-left-4",
    size: "small",
    use: "tertiary",
    upgradeData: {
      app: 'pricing-pages',
      screen: 'marketing',
      upgradeProduct: MARKETING_PRO,
      uniqueId: `basic-promo-${promoKey}`
    }
  })]
});

const MarketingBasicPromoBanner = ({
  productLine
}) => {
  const isUngatedForHalfOff = useSelector(state => isUngatedSelector(state, {
    gateKey: 'Growth:MarketingBasicPromoHalfOff'
  }));
  const isUngatedForSamePrice = useSelector(state => isUngatedSelector(state, {
    gateKey: 'Growth:MarketingBasicPromoSamePrice'
  }));
  const ttsPurchaseMotion = useSelector(state => talkToSalesTypeSelector(state, {
    productLine
  }));
  const hasMarketingBasic = useSelector(state => hasProductInProductInventorySelector(state, {
    productAttributeFilters: {
      apiName: MARKETING_HUB_BASIC
    }
  }));
  if (productLine !== MARKETING) return null;
  if (!hasMarketingBasic) return null;
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [isUngatedForHalfOff && /*#__PURE__*/_jsx(BasicPromoBanner, {
      ttsPurchaseMotion: ttsPurchaseMotion,
      promoKey: "halfOff"
    }), isUngatedForSamePrice && /*#__PURE__*/_jsx(BasicPromoBanner, {
      ttsPurchaseMotion: ttsPurchaseMotion,
      promoKey: "samePrice"
    })]
  });
};

export default MarketingBasicPromoBanner;